import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IBvaResult, IBvaReview, IAggregatedValues } from '~/services/parallel/bva.types';

const initialState: IBvaResult = {
  uuid: '',
  headcountReview: {} as IBvaReview,
  expenseReview: {} as IBvaReview,
  modelReview: {} as IBvaReview,
  expenseAggregate: {} as IAggregatedValues,
  headcountAggregate: {} as IAggregatedValues,
};

export const bvaSlice = createSlice({
  name: 'bva',
  initialState,
  reducers: {
    update: (state, action: PayloadAction<IBvaResult>) => action.payload,
    reset: () => initialState,
  },
});

export const { update } = bvaSlice.actions;

export default bvaSlice.reducer;
